import { createContext } from "react";

export const ProcedureContext = createContext({
	openFolders: [] as string[],
	setOpenFolders: (openFolders: string[]) => {},
	expandAll: false,
	setExpandAll: (expandAll: boolean) => {},
	activeStep: -1,
	setActiveStep: (activeStep: number) => {},
	activeChecklistId: 0,
	setActiveChecklistId: (activeChecklistId: number) => {},
});

export const ProcedureProvider = ProcedureContext.Provider;
export const ProcedureConsumer = ProcedureContext.Consumer;
